// A form field switched "Off" is soft-deleted rather than removed: the backend keeps the row with
// `isActive: false` and leaves `isRequired` at whatever it was, so a row can read
// `isActive: false, isRequired: true`. `isActive` is the only flag that proves a field is collected;
// filtering on `isRequired` alone lets tombstoned rows through.
export const isCollectedFormField = <T extends { isActive?: boolean }>(field: T) => field.isActive !== false;
